import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query'
import {
    STATUS_CODE_MAINTENANCE,
    STATUS_CODE_NO_SESSION,
} from 'constants/system'
import { setIsAppAccessible, setIsErrorModalOpened } from 'store/general-slice'
import { store } from 'store/store'

export interface ErrorField {
    property_path: string
    message: string
}

export const handleError = (response: unknown): void => {
    if (typeof response !== 'object' || !response) return
    if ('error' in response) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        const { status, data, error: errorMessage } = response.error

        if (errorMessage) {
            const error = { status, errorMessage }
            throw error
        }

        if (!data) return

        if ('error' in data) {
            const message = data.error
            const error = { status, message }
            throw error
        }
        if ('errors' in data) {
            const messages: ErrorField[] = []
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            // TODO: consider using 'map' instead
            data.errors.forEach(({ message, property_path }) => {
                const match = property_path.match(
                    /(?:itemsBundle\[)(\d*)\](?:.*)/
                )
                const unbundledPropertyPath = match
                    ? property_path.replace(
                          /itemsBundle\[\d*\]\.items\[\d*\]/,
                          `itemsBundle[${match[1]}]`
                      )
                    : property_path
                const unbundledError: ErrorField = {
                    message,
                    property_path: unbundledPropertyPath,
                }
                messages.push(unbundledError)
            })
            const error = { status, messages }
            console.log(error)
            throw error
        }
    }
}

interface CatchErrorByStatusProps {
    error: FetchBaseQueryError | SerializedError | MessageErrorModel
    ignored?: (number | string)[]
    callback?: (error: unknown) => void
}

export const catchErrorByStatus = ({
    error,
    ignored,
}: CatchErrorByStatusProps) => {
    if (error && 'status' in error) {
        const statusCode = error.status

        if (ignored && ignored.includes(statusCode)) return false

        switch (statusCode) {
            case STATUS_CODE_MAINTENANCE:
                store.dispatch(
                    setIsAppAccessible({
                        isAppAccessible: false,
                        statusCode,
                    })
                )
                return true
            case STATUS_CODE_NO_SESSION:
                store.dispatch(setIsErrorModalOpened(true))
                return true
            default:
                return false
            // ...other specific codes
        }
    }
    return false
}
